import { Button, Kind } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildSyncRowLabels } from 'components/buildSyncRowLabels'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import moment from 'moment-timezone'
import React from 'react'

const t = buildTranslate(
  'locations.location_list.location_detail.service_charges.sync'
)

type Props = {
  syncedAt: string | null
  isSyncing: boolean
  onSyncNow: () => void
  providerName: string
}

// Only the never-synced state is reused as-is ("Not yet synced from
// %{provider}"); every other state gets this footer's own compact
// "Last synced %{time} · Update from Toast" copy instead.
const SyncFooter = ({
  syncedAt,
  isSyncing,
  onSyncNow,
  providerName,
}: Props) => {
  const [css] = useStyletron()
  const labels = buildSyncRowLabels(providerName, syncedAt)
  const statusText = syncedAt
    ? t('last_synced', { time: moment(syncedAt).fromNow() })
    : labels.never

  const footClassName = css({
    marginTop: '14px',
    paddingTop: '12px',
    borderTop: `1px solid ${palette.grey20}`,
  })

  return (
    <div
      className={`d-flex align-items-center justify-content-end ${footClassName}`}
    >
      <Text.BodyText5 color="grey70" className="mr-xs">
        {statusText}
      </Text.BodyText5>
      <Text.BodyText5 color="grey50" className="mr-xs">
        {'·'}
      </Text.BodyText5>
      <Button
        kind={Kind.MINIMAL}
        size="small"
        className="p-0"
        onClick={onSyncNow}
        disabled={isSyncing}
      >
        <Text.BodyText5 color={palette.belizeHole}>
          {t('update_action')}
        </Text.BodyText5>
      </Button>
    </div>
  )
}

export default SyncFooter
